import {creates, hoistCmp} from '@xh/hoist/core';
import {dashContainer} from '@xh/hoist/desktop/cmp/dash';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {PerformanceTabModel} from './PerformanceTabModel';

export const performanceTab = hoistCmp.factory<PerformanceTabModel>({
    model: creates(PerformanceTabModel),
    render({model}) {
        return panel(dashContainer());
    }
});
